import { ApprovalStatus } from '../ApprovalStatus.enum'

function getLabel(val: ApprovalStatus) {
  switch (val) {
    case ApprovalStatus.APPROVED:
      return 'Approved'
    case ApprovalStatus.REJECTED:
      return 'Rejected'
    case ApprovalStatus.UNRESPONDED:
      return 'Unresponded'
    default:
      return '-'
  }
}

function getColor(val: ApprovalStatus): 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' {
  switch (val) {
    case ApprovalStatus.APPROVED:
      return 'success'
    case ApprovalStatus.REJECTED:
      return 'error'
    default:
      return 'default'
  }
}

const ApprovalStatusEnumHelper = {
  getLabel,
  getColor,
}

export default ApprovalStatusEnumHelper
